// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "IndexPageImages-module--hgwIcon-arrow-down--1S8Ck";
export var hgwIconArrowUp = "IndexPageImages-module--hgwIcon-arrow-up--1smv0";
export var indexThumbBox = "IndexPageImages-module--indexThumbBox--2-Xho";
export var indexThumbBox__item = "IndexPageImages-module--indexThumbBox__item--2JWGh";
export var isOnlyOne = "IndexPageImages-module--isOnlyOne--2eCoT";
export var animBarTypeA = "IndexPageImages-module--animBarTypeA--1nCUk";
export var animBarTypeB = "IndexPageImages-module--animBarTypeB--2Fc49";
export var animBarTypeC = "IndexPageImages-module--animBarTypeC--2FgVS";
export var animBarTypeD = "IndexPageImages-module--animBarTypeD--Yj5lq";